import { render, staticRenderFns } from "./CustomerViewDetail.vue?vue&type=template&id=31d3999a&scoped=true&lang=pug&"
import script from "./CustomerViewDetail.vue?vue&type=script&lang=js&"
export * from "./CustomerViewDetail.vue?vue&type=script&lang=js&"
import style0 from "./CustomerViewDetail.vue?vue&type=style&index=0&id=31d3999a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d3999a",
  null
  
)

export default component.exports